export const editorMentions = /@([0-9a-fA-F]{24})(\b|(?=\W))/g
export const messageMentions = /<@([0-9a-fA-F]{24})(\b|(?=\W))>/g
export const spanWithId = /<span id="([0-9a-fA-F]+)"[^>]*>([^<]*)<\/span>/g